import * as React from 'react';
import { memo } from 'react';

const SvgChevronUp = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m18 15-6-6-6 6", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgChevronUp);

export { Memo as default };
